// src/pages/Solicitacoes/components/OSGroupAccordion.jsx
import React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    useTheme,
    Box,
    Chip,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import OSGroupTable from './OSGroupTable';
import {parse, format, isValid} from 'date-fns';

export default function OSGroupAccordion({
    group,
    anchorEl,
    menuOpenId,
    handleMenuClick,
    handleMenuClose,
    handleMenuAction,
    podeMostrarMenu,
    handleGroupAction,
}) {
    const theme = useTheme();

    // 1) parseia a string "yyyyMMdd"
    const parsed = parse(group.dtAbertura, 'yyyyMMdd', new Date());
    // 2) se for data válida, formata; senão, mostra '-'
    const displayDate = isValid(parsed) ? format(parsed, 'dd/MM/yyyy') : '-';

    // detecta se este accordion é de OS já encerrada (não recebeu handleGroupAction)
    const [anchorGroupEl, setAnchorGroupEl] = React.useState(null);
    const openGroupMenu = Boolean(anchorGroupEl);
    const onGroupMenuClick = (e) => setAnchorGroupEl(e.currentTarget);
    const onGroupMenuClose = () => setAnchorGroupEl(null);
    const isClosedGroup = Boolean(group.items[0]?.dtEnc);
    const hasPendingItems = group.items.some((item) => item.status === 'Pendente');
    const hasAnyNonRejected = group.items.some((item) => item.status !== 'Rejeitado');
    const hasApprovedOrRejected = group.items.some(
        (item) => item.status === 'Aprovado' || item.status === 'Rejeitado',
    );

    return (
        <Accordion sx={{mb: 2, boxShadow: 1, borderRadius: 2, overflow: 'hidden'}}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                    // remove o padding padrão para o Box ocupar full-width
                    'px': 0,
                    '& .MuiAccordionSummary-content': {my: 0, width: '100%'},
                }}
            >
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        p: 1.5,
                        border: `1px solid ${theme.palette.grey[300]}`,
                        borderRadius: 1.5,
                        backgroundColor: theme.palette.background.paper,
                    }}
                >
                    {/* Coluna esquerda: OS e Bem em chips */}
                    <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                        <Chip
                            label={`OS ${group.numeroOS}`}
                            size="small"
                            sx={{fontWeight: 'bold'}}
                        />
                        <Chip label={`Bem ${group.bem}`} size="small" variant="outlined" />
                    </Box>

                    {/* Coluna direita: data */}
                    <Typography variant="body2" color="text.secondary">
                        Abertura: {displayDate}
                    </Typography>
                    <IconButton size="small" onClick={onGroupMenuClick}>
                        <MoreVertIcon />
                    </IconButton>
                    <Menu
                        anchorEl={anchorGroupEl}
                        open={openGroupMenu}
                        onClose={onGroupMenuClose}
                        anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                        transformOrigin={{vertical: 'top', horizontal: 'right'}}
                    >
                        {/* só exibe “Adicionar itens” se a OS ainda estiver aberta */}
                        {!isClosedGroup && (
                            <MenuItem
                                disabled={hasApprovedOrRejected}
                                onClick={() => {
                                    if (!hasApprovedOrRejected) {
                                        onGroupMenuClose();
                                        handleGroupAction(group, 'addItem');
                                    }
                                }}
                            >
                                Adicionar itens
                            </MenuItem>
                        )}
                        {!isClosedGroup && (
                            <MenuItem
                                disabled={hasPendingItems}
                                onClick={() => {
                                    if (!hasPendingItems) {
                                        onGroupMenuClose();
                                        handleGroupAction(group, 'closeGroup');
                                    }
                                }}
                            >
                                Encerrar OS
                            </MenuItem>
                        )}{' '}
                        {isClosedGroup && (
                            <MenuItem
                                disabled={!hasAnyNonRejected}
                                onClick={() => {
                                    onGroupMenuClose();
                                    handleGroupAction(group, 'anexarNotaFiscal');
                                }}
                            >
                                Anexar NF e Boleto
                            </MenuItem>
                        )}
                    </Menu>
                </Box>
            </AccordionSummary>
            <AccordionDetails>
                <OSGroupTable
                    items={group.items}
                    anchorEl={anchorEl}
                    menuOpenId={menuOpenId}
                    handleMenuClick={handleMenuClick}
                    handleMenuClose={handleMenuClose}
                    handleMenuAction={handleMenuAction}
                    podeMostrarMenu={podeMostrarMenu}
                />
            </AccordionDetails>
        </Accordion>
    );
}
